/*
 * @Author: maomao
 * @Date: 2022-08-05 下午
 * @LastEditTime:
 * 不是我喜欢的样子你都有，而是你的样子我都很喜欢
 */
import Vue from 'vue'
// 引入饿了么ui
import { Table, TableColumn, Message } from 'element-ui'
import App from './App'
import router from './router'
import axios from "axios"
// import dataV from '@jiaminghi/data-view'
// 导入全局样式
import '../src/style/index.css'
// 引入 video.js
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.use(Table)
Vue.use(TableColumn)
Vue.component(Message)
Vue.prototype.$message = Message
// Vue.prototype.$message = Message
Vue.config.productionTip = false
Vue.prototype.$video = Video
// 引入vue  自动滚动组件
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
/* eslint-disable no-new */
// import {validatanull} from '../src/utils/index'
// Vue.use(validatanull)


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js